import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-monitor/delivery";

// tbl_rem_delivery (one message each, written by the engine). Retry is Super Admin only.
const apiReminderDelivery = {
  getAll:   (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  // One message with its rendered content (an email also as sent: email_html).
  getById:  (id)      => axiosClient.get(`${BASE}/get-by-id/${id}`),
  // { rule_fid?, fromDate?, toDate? } -> { by_status, by_channel, by_day }
  getStats: (payload) => axiosClient.post(`${BASE}/get-stats`, payload),
  // { ids } re-sends FAILED messages.
  retry:    (ids)     => axiosClient.post(`${BASE}/retry`, { ids }),
};

export default apiReminderDelivery;
